<!--
 * @Author: your name
 * @Date: 2020-04-16 14:06:24
 * @LastEditTime: 2020-04-16 14:16:10
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \h5_hot_mall\src\components\iconfont.vue
 -->
<!--
		icon组件
    接收父组件的参数有：
    name：使用class形式，size：尺寸 rem，color：颜色
 -->
<template>
    <i :class="'x-icon iconfont ' + name" :style="styles" @click="iconClick"></i>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                default: ''
            },
            size: {
                type: String,
                default: ''
            },
            color: {
                type: [String, Array],
                default: ''
            }
        },
        name: 'iconfont',
        data() {
            return {}
        },
        methods: {
            isEmpty(val) {
                if (val === undefined || val === null || val === '') {
                    return true
                } else {
                    return false
                }
            },
            iconClick() {
                this.$emit('click');
            }
        },
        computed: {
            styles() {
                let style = ''
                if (!this.isEmpty(this.size)) {
                    style += `font-size: ${this.size};`
                }
                if (!this.isEmpty(this.color)) {
                    style += `color: ${this.color};`
                }
                return style
            }
        }
    }

</script>
<style scoped>
    /*字体图标库是 7dd小程序*/
    @import "//at.alicdn.com/t/c/font_1193048_7arquiqgj39.css";

    .x-icon {
        font-size: .32rem;
    }
</style>





